import { cx } from './cx';
import styles from './HazardFrame.module.css';

/** Pulsing border around the stage while the room is hazardous: amber before emission, red during. */
export function HazardFrame({ tone }: { readonly tone: 'warning' | 'danger' }) {
  return <div className={cx(styles.frame, styles[tone])} aria-hidden />;
}
